const getblen = function(str) { // 计算长度
    if (str == null) return 0;
    if (typeof str != "string"){
      str += "";
    }
    return str.replace(/[^\x00-\xff]/g,"001").length;
};
// 用户名验证
let uname = (vueObj, rule, value, callback) => {
    const reg=/[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
    if(value === ""){
        callback(new Error('登录名不可为空'));
    }else if(reg.test(value)){
        callback(new Error('登录名不可包含空格或特殊字符'));
    }else if(getblen(value) >= 32 || getblen(value) < 6){
        callback(new Error('登录名长度为6~32个字符（2~10个中文）'));
    }else{
        if(vueObj.isAdd !== undefined && !vueObj.isAdd) callback();
        vueObj.handleValidateUname(value).then((res) => {
            if(res.code == 1){
                callback(new Error(res.msg))
            }else{
                callback()
            }
        })
    }
};
// 密码验证
let pwd = (vueObj, type, rule, value, callback) => {
    const reg = /^\S*$/;
    if (value === '') {
        callback(new Error(vueObj.$t("message.register.errpwd")));
    } else if (getblen(value) >= 32 || getblen(value) < 8) {
        callback(new Error("密码长度为8~32个字符"));
    } else if (!reg.test(value)) {
        callback(new Error("密码不可包含空格"));
    } else {
        if (vueObj.form.cpwd && vueObj.form.cpwd !== '') {
            vueObj.$refs[type].validateField('cpwd');
        }
        callback();
    }
};
// 修改管理用户密码验证
let update_pwd =  (vueObj, type, rule, value, callback) => {
    const reg = /^\S*$/;
    if (value == undefined) {
        callback();
    } else if (getblen(value) >= 32 || getblen(value) < 6) {
        callback(new Error("密码长度为6~32个字符"));
    } else if (!reg.test(value)) {
        callback(new Error("密码不可包含空格"));
    } else {
        callback();
    }
};
// 密码重复验证
let cpwd = (vueObj, rule, value, callback) => {
    if (value === '') {
        callback(new Error(vueObj.$t("message.register.errcpwd")));
    } else if (value !== vueObj.form.password) {
        callback(new Error(vueObj.$t("message.register.errdiff")));
    } else {
        callback();
    }
};
// 验证码验证
let code = (vueObj, rule, value, callback) => {
    if(value === vueObj.identifyCode){
        callback();
    }else{
        callback(new Error(vueObj.$t("message.register.errcode")));
    }
}
// 邮箱验证
let email = (vueObj, required, value, callback) => {
    const reg = /^([\w.-]+@\w+([.-]\w+)+(,|$))+$/;
    if(value === ''){
        // *需要区分是否可空白
        required? callback(new Error(vueObj.$t("public.email1"))): callback();
    } else if (!reg.test(value)) {
        callback(new Error(vueObj.$t("public.email2")));
    } else {
        callback();
    }
}
export { uname, pwd, cpwd, code, email, update_pwd }
